import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65ac1c12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "textarea-wrap" }
const _hoisted_2 = ["value"]



interface IProps {
  modelValue: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Textarea',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





const updateValue = (e: Event) => {
  emit("update:modelValue", (e.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("textarea", _mergeProps({
      class: "textarea",
      value: _ctx.modelValue,
      onInput: updateValue
    }, _ctx.$attrs), null, 16, _hoisted_2)
  ]))
}
}

})